// extracted by mini-css-extract-plugin
module.exports = {"container":"Orgs_container__QGpBW","title":"Orgs_title__2marH","grid":"Orgs_grid__1h1EV","add":"Orgs_add__2aXe7"};